/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type personalizedFiltersHelpers_shippingFilters = ReadonlyArray<{
    readonly totalCount: number | null;
    readonly " $refType": "personalizedFiltersHelpers_shippingFilters";
}>;
export type personalizedFiltersHelpers_shippingFilters$data = personalizedFiltersHelpers_shippingFilters;
export type personalizedFiltersHelpers_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: personalizedFiltersHelpers_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"personalizedFiltersHelpers_shippingFilters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "personalizedFiltersHelpers_shippingFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};
(node as any).hash = '4ce009729efa2bb5edc0685db84567ae';
export default node;
